import {
  INITIALIZE_WIZARD,
  WIZARD_CONTINUE,
  WIZARD_BACK,
  CAMPAIGNS_BUSY,
  GET_CAMPAIGN_DATA_SUCCESS,
  GET_CAMPAIGN_DATA_ERROR,
  CREATE_CAMPAIGN_SUCCESS,
  CREATE_CAMPAIGN_ERROR,
  EDIT_CAMPAIGN_SUCCESS,
  EDIT_CAMPAIGN_ERROR,
  BANNER_ERROR,
  LOGO_ERROR,
  RICH_EDITOR_ERROR,
  WIZARD_SET_CURRENT_PAGE,
  OPEN_MOBILE_PREVIEW,
  CLOSE_MOBILE_PREVIEW,
  INITIALIZE_DESCRIPTION,
  DRAFT_CAMPAIGNS_BUSY,
  IS_DRAFT_CAMPAIGN,
  RESET_CAMPAIGN_STORE,
} from '../actions/actionsCampaigns';
import { getNextStep, getPreviousStep } from '../utilsV3/campaignUtils.js';
import { getOptionsForLanguageField } from '../utilsV3/commonUtils';
import { transformServerFormatToClient } from '../lib/campaignsModel';
import { getServerProps } from '../utilsV3/serverProps';
import _get from 'lodash/get';
import { COUNTRIES_AND_PERMIT_CURRENCY } from '../clientConstants';
import { getDefaultEndTime } from '../utilsV3/dateUtils';

const businessProfileLogoUrl =
  _get(getServerProps(), 'businessImageUrls.url') || '';

const receiverName = _get(getServerProps(), 'receiverName', '');

export const LOGO_TARGET_CAMPAIGN = 'CAMPAIGN';
export const LOGO_TARGET_PROFILE = 'PROFILE';
export const LOGO_TARGET_NOLOGO = 'NOLOGO';

const getDefaultValueForLanguage = () => {
  const serverProps = getServerProps();
  const countryAndLanguageDetails = _get(
    serverProps,
    'countryAndLanguageDetails'
  );
  const selectedCountry = _get(serverProps, 'selectedCountry');
  const languages = getOptionsForLanguageField(
    countryAndLanguageDetails,
    selectedCountry
  );
  // Get first language
  return _get(languages, '[0].value', 'en');
};

// TODO: need to clean up default Campaign before launch
const defaultCampaign = {
  startTime: 0,
  status: 'DRAFT',
  currencyCode: _get(getServerProps(), 'primaryCurrency[0]', 'USD'),
  countryCode: getServerProps().country,
  language: getDefaultValueForLanguage(),
  campaignType: 'DONATE_BUTTON_CAMPAIGN',
  receiverName: receiverName,
  eventType: 'external',
  eventTitle: '',
  eventUrl: undefined,
  bannerImageUrl: '',
  logoUrl: '',
  businessProfileLogoUrl: businessProfileLogoUrl,
  noLogoImage: businessProfileLogoUrl ? 'no' : 'yes',
  logoTarget: businessProfileLogoUrl ? LOGO_TARGET_PROFILE : LOGO_TARGET_NOLOGO,
  cancelReturn: '',
  return: '',
  recurringEnabled: 'yes',
  anonymousSelection: 1,
  coverFeesEnabled: 'yes',
  note: 1,
  noShipping: 'yes',
  previewType: 0,
  amountValue: '',
  merchantAmount1: '',
  merchantAmount2: '',
  merchantAmount3: '',
  postalCode: '945879',
  categories: ['x', 'y'],
  TotalAmount: '0.00',
  transactionCount: 0,
  participants: [],
  tid: 117625766824388220,
  targetReached: false,
  donationLimitReached: false,
  netAmount: '0.00',
  hasEndTime: 'no',
  endTime: getDefaultEndTime(),
  amountType: 'variable',
  template_data: '{}',
  buttonSize: 'large',
  targetAmount: 10000,
  usePaypalButtonStyle: 'yes',
  buttonImageUrl: '',
  showAcceptedCardLogos: false,
  imgButtonStylesError: '',
  noPaypalButtonStyles: 'yes',
  noCancelReturn: 'yes',
  description: [],
  noEmbedWidget: 'no',
  embedWidget: { image: '', description: '' },
  draftMeta: { draftVersion: '0', draftStep: '0' },
  timeUpdated: null,
};

export const initialState = {
  formattedCampaign: defaultCampaign,
};

const defaultState = {
  currentStep: 1,
  totalSteps: 4,
  busy: true,
  draftBusy: true,
  bannerImageError: false,
  logoImageError: false,
  isMobilePreviewOpen: false,
};

function getFormattedCampaign(payload) {
  return Object.assign({}, transformServerFormatToClient(payload));
}

function getClientSideStateByCountry(state) {
  const countries = Object.keys(COUNTRIES_AND_PERMIT_CURRENCY);
  if (countries.includes(state.formattedCampaign.countryCode)) {
    return {
      formattedCampaign: {
        ...state.formattedCampaign,
        currencyCode:
          COUNTRIES_AND_PERMIT_CURRENCY[state.formattedCampaign.countryCode],
      },
    };
  }

  return state;
}

export default function campaigns(state = defaultState, action) {
  switch (action.type) {
    case INITIALIZE_WIZARD: {
      const campaign = action.payload;
      const clientSideState = getClientSideStateByCountry(initialState);
      return {
        ...state,
        campaign,
        formattedCampaign: campaign || clientSideState.formattedCampaign,
        busy: false,
        draftBusy: false,
        isDraft: false,
      };
    }

    case INITIALIZE_DESCRIPTION: {
      return {
        ...state,
        formattedCampaign: {
          ...state.formattedCampaign,
          description: action.payload,
        },
      };
    }

    case WIZARD_CONTINUE: {
      const { currentStep } = state;

      return {
        ...state,
        currentStep: getNextStep(currentStep),
      };
    }

    case WIZARD_BACK: {
      const { currentStep } = state;

      return {
        ...state,
        currentStep: getPreviousStep(currentStep),
      };
    }

    case WIZARD_SET_CURRENT_PAGE: {
      return {
        ...state,
        currentStep: action.payload,
      };
    }

    case IS_DRAFT_CAMPAIGN: {
      return {
        ...state,
        isDraft: action.payload,
      };
    }

    case CAMPAIGNS_BUSY: {
      return {
        ...state,
        busy: true,
      };
    }

    case DRAFT_CAMPAIGNS_BUSY: {
      return {
        ...state,
        draftBusy: true,
      };
    }

    case GET_CAMPAIGN_DATA_SUCCESS: {
      const { campaign, isDuplicated } = action.payload;
      const status = isDuplicated ? 'ACTIVE' : campaign.status;
      const startTime = campaign.start_time ?? 0;

      const formattedCampaign = getFormattedCampaign({
        ...campaign,
        status,
        businessProfileLogoUrl: businessProfileLogoUrl,
        start_time: startTime,
      });
      const draftStep = parseInt(
        formattedCampaign.draftMeta?.draftStep || '0',
        10
      );
      const currentStep =
        status === 'DRAFT' && draftStep > 0 ? draftStep : state.currentStep;

      const isDraft = status === 'DRAFT';

      return {
        ...state,
        campaign: { ...campaign, status },
        formattedCampaign,
        currentStep,
        busy: false,
        draftBusy: false,
        isDraft: isDraft,
      };
    }

    case GET_CAMPAIGN_DATA_ERROR: {
      const { error } = action.payload;
      return {
        ...state,
        error,
        busy: false,
        draftBusy: false,
      };
    }

    case CREATE_CAMPAIGN_SUCCESS: {
      const formattedCampaign = getFormattedCampaign({
        ...action.payload,
        businessProfileLogoUrl,
      });
      return {
        ...state,
        campaign: formattedCampaign,
        formattedCampaign,
        busy: false,
        draftBusy: false,
        error: null,
        isCampaignCreated: true,
      };
    }
    case CREATE_CAMPAIGN_ERROR: {
      const { error } = action.payload;
      return {
        ...state,
        error,
        busy: false,
        draftBusy: false,
      };
    }

    case EDIT_CAMPAIGN_SUCCESS: {
      const campaign = action.payload;
      const { currentStep, isDraft } = state;
      let isCampaignCreated = isDraft && currentStep === 4;

      return {
        ...state,
        campaign: campaign,
        busy: false,
        draftBusy: false,
        error: null,
        isCampaignCreated: isCampaignCreated,
      };
    }

    case EDIT_CAMPAIGN_ERROR: {
      const { error } = action.payload;
      return {
        ...state,
        error,
        busy: false,
        draftBusy: false,
        isCampaignCreated: false,
      };
    }

    case BANNER_ERROR: {
      const { error } = action.payload;
      return {
        ...state,
        bannerImageError: error,
      };
    }

    case LOGO_ERROR: {
      const { error } = action.payload;
      return {
        ...state,
        logoImageError: error,
      };
    }

    case RICH_EDITOR_ERROR: {
      const { error } = action.payload;
      return {
        ...state,
        richEditorError: error,
      };
    }

    case OPEN_MOBILE_PREVIEW: {
      return {
        ...state,
        isMobilePreviewOpen: true,
      };
    }

    case CLOSE_MOBILE_PREVIEW: {
      return {
        ...state,
        isMobilePreviewOpen: false,
      };
    }

    case RESET_CAMPAIGN_STORE: {
      return {
        ...defaultState,
      };
    }

    default:
      return state;
  }
}
